import { useState } from "react"
import { NavLink, Outlet, useNavigate } from "react-router-dom"

// MUI
import { Assignment, Collections, ContactMail, Home, Login, Menu as MenuIcon, School, VerifiedUser } from "@mui/icons-material"
import { AppBar, Box, Drawer, IconButton, Stack, Toolbar, Typography, useTheme } from "@mui/material"

import Footer from "./footer"

export default function Header() {
	let navi = useNavigate()
	const theme = useTheme()
	const [drawerOpen, setDrawerOpen] = useState(false)

	const links = [
		{ name: "Home", link: "/", icon: Home },
		{ name: "Gallery", link: "/gallery", icon: Collections },
		{ name: "Courses", link: "/courses", icon: School },
		{ name: "Home Work", link: "/homework", icon: Assignment },
		{ name: "Contact", link: "/contact", icon: ContactMail },
		{ name: "Verification", link: "/verification", icon: VerifiedUser },
		{ name: "Login", link: "https://app.spywarecomputers.com/student", icon: Login },
	]

	const toggleDrawer = (open) => (event) => {
		if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
			return
		}
		setDrawerOpen(open)
	}

	return (
		<>
			<AppBar
				color="primary"
				position="sticky"
				elevation={0}
				sx={{
					top: 0,
					zIndex: 1100,
					boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
				}}
			>
				<Toolbar>
					<Box sx={{ flexGrow: 1, textAlign: { md: "left", xs: "left" } }}>
						<img src="/logo_text_white.png" alt="Spyware Computer Education Logo" style={{ borderRadius: 0, width: "180px" }} />
					</Box>

					{/* Desktop Navigation */}
					<Stack spacing={2} direction="row" sx={{ display: { xs: "none", md: "flex" } }}>
						{links.map((row, i) =>
							row.link.startsWith("http") ? (
								<a
									href={row.link}
									target="_blank"
									rel="noopener noreferrer"
									style={{ fontWeight: 400, textDecoration: "none", textTransform: "uppercase", color: theme.palette.primary.contrastText }}
									key={i}
								>
									{row.name}
								</a>
							) : (
								<NavLink
									to={row.link}
									style={({ isActive }) => {
										return { fontWeight: 400, textDecoration: "none", textTransform: "uppercase", color: isActive ? theme.palette.secondary.main : theme.palette.primary.contrastText }
									}}
									key={i}
								>
									{row.name}
								</NavLink>
							)
						)}
					</Stack>

					{/* Mobile Menu Button */}
					<IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer(true)} sx={{ display: { xs: "flex", md: "none" } }}>
						<MenuIcon />
					</IconButton>
				</Toolbar>
			</AppBar>

			{/* Mobile Drawer */}
			<Drawer
				anchor="bottom"
				open={drawerOpen}
				onClose={toggleDrawer(false)}
				sx={{
					display: { xs: "block", md: "none" },
					"& .MuiDrawer-paper": {
						background: theme.palette.primary.main,
						color: theme.palette.primary.contrastText,
						borderTopLeftRadius: 16,
						borderTopRightRadius: 16,
						maxHeight: "80vh",
					},
				}}
			>
				<Box sx={{ p: 2, display: "flex", justifyContent: "center", alignItems: "center", borderBottom: `1px solid ${theme.palette.secondary.main}30` }}>
					<Box sx={{ width: 40, height: 4, borderRadius: 2, background: theme.palette.secondary.main, opacity: 0.5 }} />
				</Box>
				<Box sx={{ p: 3, pb: 4 }}>
					<Box
						sx={{
							display: "grid",
							gridTemplateColumns: "repeat(2, 1fr)",
							gap: 2,
						}}
					>
						{links.map((item, index) => {
							const Icon = item.icon
							return (
								<Box
									key={index}
									onClick={() => {
										if (item.link.startsWith("http")) {
											window.open(item.link, "_blank", "noopener,noreferrer")
										} else {
											navi(item.link)
										}
										setDrawerOpen(false)
									}}
									sx={{
										p: 2.5,
										borderRadius: 3,
										background: `linear-gradient(135deg, ${theme.palette.secondary.main}15, ${theme.palette.info.main}15)`,
										border: `1px solid ${theme.palette.secondary.main}30`,
										cursor: "pointer",
										transition: "all 0.3s ease",
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 1.5,
										position: "relative",
										overflow: "hidden",
										"&::before": {
											content: '""',
											position: "absolute",
											top: 0,
											left: 0,
											right: 0,
											bottom: 0,
											background: `linear-gradient(135deg, ${theme.palette.secondary.main}20, ${theme.palette.info.main}20)`,
											opacity: 0,
											transition: "opacity 0.3s ease",
										},
										"&:hover": {
											transform: "translateY(-5px)",
											boxShadow: `0 8px 24px ${theme.palette.secondary.main}40`,
											"&::before": {
												opacity: 1,
											},
										},
									}}
								>
									<Box
										sx={{
											width: 50,
											height: 50,
											borderRadius: 2,
											background: `linear-gradient(135deg, ${theme.palette.secondary.main}30, ${theme.palette.info.main}30)`,
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											position: "relative",
											zIndex: 1,
										}}
									>
										<Icon sx={{ fontSize: "1.8rem", color: theme.palette.secondary.main }} />
									</Box>
									<Typography
										sx={{
											color: theme.palette.primary.contrastText,
											fontWeight: 600,
											fontSize: "0.9rem",
											textAlign: "center",
											position: "relative",
											zIndex: 1,
										}}
									>
										{item.name}
									</Typography>
								</Box>
							)
						})}
					</Box>
				</Box>
			</Drawer>

			<Box>
				<Outlet />
			</Box>
			<Box>
				<Footer />
			</Box>
		</>
	)
}
